import advRegister from '@/components/sign-log/advertising-register/register.js';
const COOKIE_AUTHORITY_KEY = 'COOKIE_AUTHORITY_QUERY';
const themeMap = {
    standard: () =>
        import(
            /* webpackChunkName: "common/cookie-authority/standard" */ './theme/standard.vue'
        )
};

/**
 * 条件: 1. 未登录 2. 未询问 3. 非AD
 */
function init(Vue, store) {
    const iscms = window.sitePageAutoInit === false;
    const isCmsListing = window.location.href.includes('/listing-for-cms');
    // 排除广告页 和 cms
    const isAd = /x_ads_source/.test(location.search);
    if (isAd || iscms || isCmsListing) {
        return;
    }
    if (
        (window.sitePrepareData &&
            window.sitePrepareData()._disableCookieAuthority) ||
        (advRegister.isShow() &&
            window.sitePrepareData &&
            window.sitePrepareData().isLandingPage)
    ) {
        return;
    }

    let cookieAuthority = null;
    let hasQerried = localStorage.getItem(COOKIE_AUTHORITY_KEY);
    const isSitePrivacy = location.href.includes(
        '/site/privacy-terms#privacy-policy'
    );

    if (hasQerried == '0' && !isSitePrivacy) {
        hasQerried = '';
        localStorage.removeItem(COOKIE_AUTHORITY_KEY);
    }
    store
        .dispatch('getUser', {
            checkOtherIframe: true,
            fromGlobal: true
        })
        .then(isLogin => {
            const { template } = sitePrepareData() || {};
            if (
                !isLogin &&
                (!hasQerried || (hasQerried == '0' && isSitePrivacy))
            ) {
                const compFn = themeMap[template] || themeMap['standard'];
                compFn()
                    .then(comp => comp.default)
                    .then(compConfig => {
                        cookieAuthority = new Vue(compConfig).$mount();
                        // 挂载
                        document.body.appendChild(cookieAuthority.$el);
                        cookieAuthority.$on('hidden', () => {
                            localStorage.setItem(COOKIE_AUTHORITY_KEY, '1');
                            // 动画执行之后再移除
                            setTimeout(() => {
                                if (cookieAuthority) {
                                    cookieAuthority.$destroy();
                                    cookieAuthority = null;
                                }
                            }, 1000);
                        });
                        if (hasQerried == '0') {
                            cookieAuthority.setVisible(true);
                        } else {
                            setTimeout(() => {
                                localStorage.setItem(COOKIE_AUTHORITY_KEY, '0');
                                cookieAuthority.setVisible(true);
                            }, 5000);
                        }
                    });
            }
        });

    // 监听用户登录, 用户没有关闭弹框登录了需要关掉
    siteAppVm.$EventBus.$on('userLogin', user => {
        if (
            cookieAuthority &&
            localStorage.getItem(COOKIE_AUTHORITY_KEY) != '1'
        ) {
            cookieAuthority.setVisible(false);
            localStorage.removeItem(COOKIE_AUTHORITY_KEY);
            setTimeout(() => {
                cookieAuthority.$destroy();
                cookieAuthority = null;
            }, 1000);
        }
    });
}

export default init;
